import { Component, Input, inject } from '@angular/core'
import { fadeInUpAnimation } from '@app/shared/animations/common-animations'
import { Router } from '@angular/router'

@Component({
    selector: 'app-dashboard-header',
    templateUrl: './dashboard-header.component.html',
    styleUrls: ['./dashboard-header.component.scss'],
    animations: [fadeInUpAnimation],
})
export class DashboardHeaderComponent {
    private router = inject(Router)

    @Input() title = 'Home'
    @Input() subtitle = "Welcome Back, Let's navigate success"
    @Input() buttonText = 'Add New Client'

    onAddClient(): void {
        this.router.navigate(['/crm/create'])
    }
}
